// Shared auth state (no Pinia for MVP)
// ADR-WEB-12.31 件B PR5: multi-account state + switchAccount
import { reactive, readonly } from 'vue'
import { api } from '../lib/api.js'

const state = reactive({
  email: null,
  loading: false,
  initialized: false,
  activeAccount: 'testnet',       // 当前激活账户 (testnet|live|copy)
  accounts: ['testnet'],          // 后端 SUPPORTED_ACCOUNTS, whoami 返
})

// ADR-WEB-12.34 r2: 暴露 activeAccount 到 window 给 api.js unwrap() 做 inflight guard
function _syncWindowAccount(acct) {
  if (typeof window !== 'undefined') {
    window._maris_active_account = acct || 'testnet'
  }
}

async function refresh() {
  try {
    const { data } = await api.whoami()
    state.email = data?.email ?? null
    state.activeAccount = data?.active_account || 'testnet'
    state.accounts = data?.accounts || ['testnet']
    _syncWindowAccount(state.activeAccount)
  } catch (_e) {
    state.email = null
  } finally {
    state.initialized = true
  }
}

async function switchAccount(account) {
  // 同 session attribute, 不开新登录 (backend PR4)
  try {
    const { data } = await api.switchAccount(account)
    state.activeAccount = data?.active_account || account
    state.accounts = data?.accounts || state.accounts
    _syncWindowAccount(state.activeAccount)
    return state.activeAccount
  } catch (e) {
    console.error('[useAuth] switchAccount failed:', e)
    throw e
  }
}

async function login(email, password) {
  state.loading = true
  try {
    await api.login(email, password)
    await refresh()
  } finally {
    state.loading = false
  }
}

async function logout() {
  try {
    await api.logout()
  } catch (_e) { /* tolerate */ }
  state.email = null
  window.location.href = '/login'
}

export function useAuth() {
  return {
    state: readonly(state),
    refresh,
    login,
    logout,
    switchAccount,
  }
}
